import { GrowthCalendarItem } from './growth-marketing.service';

export interface GrowthContentCalendarMonthDay {
  date: Date;
  key: string;
  inMonth: boolean;
  isToday: boolean;
}

export function utcDayKey(iso: string | null | undefined): string | null {
  if (!iso?.trim()) {
    return null;
  }

  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return `${parsed.getUTCFullYear()}-${String(parsed.getUTCMonth() + 1).padStart(2, '0')}-${String(parsed.getUTCDate()).padStart(2, '0')}`;
}

export function buildMonthGrid(year: number, month: number): GrowthContentCalendarMonthDay[] {
  const firstOfMonth = new Date(Date.UTC(year, month, 1));
  const startOffset = firstOfMonth.getUTCDay();
  const gridStart = new Date(Date.UTC(year, month, 1 - startOffset));
  const todayKey = utcDayKey(new Date().toISOString());
  const days: GrowthContentCalendarMonthDay[] = [];

  for (let index = 0; index < 42; index += 1) {
    const date = new Date(Date.UTC(
      gridStart.getUTCFullYear(),
      gridStart.getUTCMonth(),
      gridStart.getUTCDate() + index
    ));
    const key = utcDayKey(date.toISOString()) ?? '';
    days.push({
      date,
      key,
      inMonth: date.getUTCMonth() === month,
      isToday: key === todayKey
    });
  }

  return days;
}

export function monthRangeUtc(year: number, month: number): { fromUtc: string; toUtc: string } {
  const fromUtc = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0)).toISOString();
  const toUtc = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999)).toISOString();
  return { fromUtc, toUtc };
}

export function groupCalendarItemsByDay(items: GrowthCalendarItem[]): Map<string, GrowthCalendarItem[]> {
  const grouped = new Map<string, GrowthCalendarItem[]>();

  for (const item of items) {
    const key = utcDayKey(item.scheduledAtUtc);
    if (!key) {
      continue;
    }

    const bucket = grouped.get(key) ?? [];
    bucket.push(item);
    grouped.set(key, bucket);
  }

  for (const bucket of grouped.values()) {
    bucket.sort((left, right) => left.scheduledAtUtc.localeCompare(right.scheduledAtUtc));
  }

  return grouped;
}

export function formatMonthLabel(year: number, month: number, locale: string): string {
  return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(
    new Date(Date.UTC(year, month, 1))
  );
}
